
const validFieldsForQuantVizLookup = [
    "DropdownSingle",
    "DropdownMulti",
    "RadioList",
    "CheckboxList",
    "TagsInputSingle",
    "TagsInputMulti",
    "NumberInput",
    "GroupQuestionsInputSingle"
  ];

  const validFieldsForBreakingdown = [
    "DropdownSingle",
    "DropdownMulti",
    "RadioList",
    "CheckboxList",
    "TagsInputSingle",
    "TagsInputMulti",
    // "NumberInput",
    // "GroupQuestionsInputSingle" //maybe we could use this in the future, but it would have to be split into its subQuestions
  ];
  
  export const getValidFieldsForQuantViz = (blocks) => {
    return blocks.filter((d) => validFieldsForQuantVizLookup.includes(d.comp))
  }

  export const getValidBreakdownFields = (blocks) => {
    return blocks.filter((d) => validFieldsForBreakingdown.includes(d.comp))
  }